<form [formGroup]="formGroup" class="search-two" (ngSubmit)="doSearch()">
    <button class="search-two--button" type="submit" aria-label="Search">
        <svg id="sprite-search" viewBox="0 0 19.8 19.8">
            <title>search</title>
            <path
                d="M13.4 12.8c1.2-1.4 1.9-3.1 1.9-5.1 0-4.2-3.4-7.7-7.7-7.7S0 3.4 0 7.7s3.4 7.7 7.7 7.7c2 0 3.7-.7 5.1-1.9l6.4 6.4.6-.6-6.4-6.5zm-5.7 1.7C4 14.5.9 11.5.9 7.7S3.9.9 7.7.9s6.8 3 6.8 6.8-3.1 6.8-6.8 6.8z">
            </path>
        </svg>
    </button>
    <input formControlName="searchInput" type="text" class="form-control search-two--input" placeholder="Search..."
        name="search">
</form>